import React, { useEffect } from 'react';

import { isNetquestClient, isPureProfileClient } from '../../utils/platform';

export const DocumentTitle: React.FC = () => {
  useEffect(() => {
    if (isNetquestClient()) {
      document.title = 'Flashsurvey';
      return;
    }
    if (isPureProfileClient()) {
      document.title = 'Datarubico Survey';
      return;
    }
  }, []);

  return null;
};
